// extracted by mini-css-extract-plugin
export default {"ContentFormContainer":"ContentTypeToggle_ContentFormContainer__VgGHt"};